export default ({
  itemQuantity = null,
  returnComment = '',
  returnQuantity = 0,
  selectedReason = null,
  commentRequired = false,
  commentHidden = false,
}) => ({
  itemQuantity,
  returnComment,
  returnQuantity,
  selectedReason,
  commentRequired,
  commentHidden,
});
